"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactNativeWeb = require("react-native-web");

var _AaCalendar = require("../AaCalendar.utilities");

var _crossPlatformComponents = require("@airasia/cross-platform-components");

var _AaCalendar2 = require("../AaCalendar.model");

var _uiUtils = require("@airasia/ui-utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
var weekDaysNames = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
var weekDaysKeys = ['Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat', 'Sun'];

var AaCalendarInstance = function AaCalendarInstance(props) {
  var today = new Date();
  var itemsRef = (0, _react.useRef)([]);
  var checkIfDateIsPreviousOfStartDate = _AaCalendar.AaCalendarUtilities.checkIfDateIsPreviousOfStartDate;
  var checkIfDateIsPreviousOrEqualOfStartDate = _AaCalendar.AaCalendarUtilities.checkIfDateIsPreviousOrEqualOfStartDate;
  var checkIfDateAreSame = _AaCalendar.AaCalendarUtilities.checkIfDateAreSame;
  var isPriceLoaded = false;
  var maxDate = null;
  var lastHoveredDate;
  var blanks = [];
  var days = [];
  var dateObj;

  if (props.controls.maxDate) {
    maxDate = new Date(props.controls.maxDate);
  }

  if (props.controls && props.controls.year && props.controls.month !== null) {
    dateObj = new Date(props.controls.year, props.controls.month); //new Date(year, month, day, hours, minutes, seconds, milliseconds)
  } else {
    dateObj = new Date();
  }

  (0, _react.useEffect)(function () {
    if (!props.controls.resetData) {
      return;
    }

    resetHoverDates(new Date(props.data.checkinDate.year, props.data.checkinDate.month, props.data.checkinDate.date), new Date(props.data.checkoutDate.year, props.data.checkoutDate.month, props.data.checkoutDate.date));
  }, [props.controls.resetData]);
  (0, _react.useEffect)(function () {
    // resetHoverDates(new Date(props.data.checkinDate.year, props.data.checkinDate.month, props.data.checkinDate.date),
    //                 new Date(props.controls.maxDate.getFullYear(), props.controls.maxDate.getMonth(), props.controls.maxDate.getDate()));
    //resets first day to last day of the month for this calendar instance
    resetHoverDates(dateObj, new Date(dateObj.getFullYear(), dateObj.getMonth() + 1, 0));
  }, [props.data]);

  var _useState = (0, _react.useState)("".concat(monthNames[dateObj.getMonth()], " ").concat(dateObj.getFullYear())),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      calendarLabel = _useState2[0],
      setCalendarLabel = _useState2[1];

  var getDaysInMonth = function getDaysInMonth(month, year) {
    return new Date(year, month + 1, 0).getDate();
  };

  var getWeekDayIndex = function getWeekDayIndex(month, year) {
    return new Date(year, month, 0).getDay();
  };

  var daysOfCurrentMonth = getDaysInMonth(dateObj.getMonth(), dateObj.getFullYear());
  var dayStart = getWeekDayIndex(dateObj.getMonth(), dateObj.getFullYear());

  var createBlanks = function createBlanks() {
    for (var i = 0; i < dayStart; i++) {
      blanks.push(" ");
    }
  };

  var getPrice = function getPrice(day) {
    if (!day || Number.isNaN(day)) {
      return;
    }

    if (!props.lfcPrices) {
      return;
    }

    var formattedDate = _AaCalendar.AaCalendarUtilities.datePayloadFormat(new Date(dateObj.getFullYear(), dateObj.getMonth(), day));

    if ((!props.lfcPrices || !props.lfcPrices.oneway || !props.lfcPrices["return"]) && props.controls.selectionType === _AaCalendar2.CALENDAR_SELECTION_TYPE.TWO) {
      return;
    }

    if (props.controls.selectForCheckin && props.lfcPrices && props.lfcPrices.oneway && !props.data.checkoutDate.date) {
      var price = props.lfcPrices.oneway[formattedDate];

      if (!price) {
        return;
      }

      isPriceLoaded = true;
      return _AaCalendar.AaCalendarUtilities.exchangeRateConverter(price, props.controls.currencyDetails.exchangeRate); // return AaCalendarUtilities.currencyFormatter(price, 2);
    }

    if (props.lfcPrices.oneway && props.controls.selectForCheckout && props.lfcPrices && props.lfcPrices["return"] || props.data.checkinDate.date && props.data.checkoutDate.date) {
      var priceOneWay = 0;
      var priceReturn = 0;

      if (props.lfcPrices.oneway) {
        priceOneWay = props.lfcPrices.oneway[formattedDate];
      }

      if (props.lfcPrices["return"]) {
        priceReturn = props.lfcPrices["return"][formattedDate];
      }

      if (priceOneWay === 0 && priceReturn === 0) {
        return;
      }

      isPriceLoaded = true;

      var departPrice = _AaCalendar.AaCalendarUtilities.exchangeRateConverter(props.controls.departPrice, props.controls.currencyDetails.exchangeRate);

      var returnPrice = _AaCalendar.AaCalendarUtilities.exchangeRateConverter(priceReturn, props.controls.currencyDetails.exchangeRate);

      var totalPrice = departPrice + returnPrice;
      return totalPrice; // return  AaCalendarUtilities.currencyFormatter(totalPrice, 2)
    }

    return '';
  };

  var createDays = function createDays() {
    for (var i = 1; i <= daysOfCurrentMonth; i++) {
      days.push({
        label: i,
        price: getPrice(i)
      });
    }
  };

  createBlanks();
  createDays();
  var totalSlots = [].concat(blanks, days);
  var rows = [];
  var cells = [];

  var createCellsRows = function createCellsRows() {
    totalSlots.forEach(function (row, i) {
      if (i % 7 !== 0) {
        cells.push(row); // if index not equal 7 that means not go to next week
      } else {
        rows.push(cells); // when reach next week we contain all td in last week to rows

        cells = []; // empty container

        cells.push(row); // in current loop we still push current row to new container
      }

      if (i === totalSlots.length - 1) {
        // when end loop we add remain date
        rows.push(cells);
      }
    });
    var lastElementLength = rows[rows.length - 1].length;

    if (lastElementLength < 7) {
      var loopLimit = 7 - lastElementLength;

      for (var i = 1; i <= loopLimit; i++) {
        rows[rows.length - 1].push(" ");
      }
    }
  };

  createCellsRows();
  var weeks = rows; // let calendarLabel = `${monthNames[dateObj.getMonth()]} ${dateObj.getFullYear()}`
  // const calendarLabel = `${monthNames[dateObj.getMonth()]} ${dateObj.getFullYear()}`;
  // setCalendarLabel(AaCalendarUtilities.setNoDayFormat(dateObj));

  (0, _react.useEffect)(function () {
    if (!props.controls.dataFormatDate) {
      return;
    }

    if (!props.controls.dataFormatDate.userData || !props.controls.dataFormatDate.userData.data) {
      return;
    }

    if (!props.controls.dataFormatDate.userData.data.date.noDay) {
      return;
    }

    setCalendarLabel(_AaCalendar.AaCalendarUtilities.setNoDayFormat(dateObj));
    var day = props.controls.dataFormatDate.userData.data.letterDaysTranslation;
    weekDaysNames = [day.mon, day.tue, day.wed, day.thu, day.fri, day.sat, day.sun];
  }, [props.controls.dataFormatDate, dateObj]);

  var dayPress = function dayPress(d) {
    var dateTemp = new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label);

    var formattedDate = _AaCalendar.AaCalendarUtilities.datePayloadFormat(new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label));

    if (!checkIfDateIsPreviousOfStartDate(dateTemp, maxDate) || checkIfDateIsPreviousOfStartDate(dateTemp, today)) {
      return;
    }

    var dateToReturn = new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label);
    var price = props.lfcPrices.oneway && props.lfcPrices.oneway[formattedDate] ? props.lfcPrices.oneway[formattedDate] : null;

    if (props.controls.selectForCheckin) {
      props.controls.onDepartSelected(dateToReturn, price);

      if (props.data.checkoutDate.month && props.data.checkoutDate.date) {
        onHoverDates(dateTemp, new Date(props.data.checkoutDate.year, props.data.checkoutDate.month, props.data.checkoutDate.date));
        var currentReturnDate = new Date(dateObj.getFullYear(), props.data.checkoutDate.month, props.data.checkoutDate.date);

        var isAheadOfReturn = _AaCalendar.AaCalendarUtilities.checkIfDateIsAheadOfStartDate(dateToReturn, currentReturnDate);

        if (isAheadOfReturn) {
          props.controls.onReturnSelected(null);
        }
      }
    } else if (props.controls.selectForCheckout) {
      var checkinDate = props.data.checkinDate;
      var checkinDateObj = new Date(checkinDate.year, checkinDate.month, checkinDate.date);

      if (checkIfDateIsPreviousOrEqualOfStartDate(dateToReturn, checkinDateObj)) {
        return;
      }

      props.controls.onReturnSelected(dateToReturn);
      onHoverDates(new Date(props.data.checkinDate.year, props.data.checkinDate.month, props.data.checkinDate.date), dateToReturn);
    }
  };

  var toHover = function toHover(day) {
    if (props.controls.selectionType === _AaCalendar2.CALENDAR_SELECTION_TYPE.ONE) {
      return false;
    }

    var departSelectedDate = new Date(props.data.checkinDate.year, props.data.checkinDate.month, props.data.checkinDate.date);
    var dateOnHover = new Date(dateObj.getFullYear(), dateObj.getMonth(), day);

    var daysDiff = _AaCalendar.AaCalendarUtilities.dayDifference(departSelectedDate, dateOnHover);

    var isValidRange = checkIfDateIsPreviousOrEqualOfStartDate(dateOnHover, maxDate);
    return daysDiff > 0 && isValidRange;
  };

  var onHoverDates = function onHoverDates(startDate, endDate) {
    if (props.controls.selectionType === _AaCalendar2.CALENDAR_SELECTION_TYPE.ONE) {
      return;
    }

    var newDate = startDate;
    var isValidRange = checkIfDateIsPreviousOrEqualOfStartDate(endDate, maxDate);
    var lastDateToHover = isValidRange ? endDate : maxDate;

    var daysDiff = _AaCalendar.AaCalendarUtilities.dayDifference(startDate, lastDateToHover);

    resetHoverDates(startDate, new Date(props.controls.maxDisplayedDate.getFullYear(), props.controls.maxDisplayedDate.getMonth() + 1, 0));
    lastHoveredDate = endDate;

    if (daysDiff < 0 || Number.isNaN(daysDiff)) {
      return false;
    }

    for (var i = 0; i <= daysDiff; i++) {
      if (_reactNativeWeb.Platform.OS === 'web') {
        var e = document.getElementById("hotel-View-".concat(newDate.getFullYear(), "-").concat(newDate.getMonth(), "-").concat(newDate.getDate()));
        newDate = _AaCalendar.AaCalendarUtilities.addDaysToDate(newDate, 1);

        if (!e) {
          continue;
        }

        e.style.backgroundColor = "rgba(75, 79, 166, 0.1)";
      }

      if (_reactNativeWeb.Platform.OS === 'android' || _reactNativeWeb.Platform.OS === "ios") {
        var _e = itemsRef.current["hotel-View-".concat(newDate.getFullYear(), "-").concat(newDate.getMonth(), "-").concat(newDate.getDate())];
        newDate = _AaCalendar.AaCalendarUtilities.addDaysToDate(newDate, 1);

        if (!_e) {
          continue;
        }

        _e.setNativeProps({
          backgroundColor: "rgba(75, 79, 166, 0.1)"
        });
      }
    }
  };

  var resetHoverDates = function resetHoverDates(startDate, endDate) {
    if (!startDate || !endDate) {
      return;
    }

    var newDate = endDate;

    var daysDiff = _AaCalendar.AaCalendarUtilities.dayDifference(startDate, endDate);

    if (daysDiff < 0 || Number.isNaN(daysDiff)) {
      return false;
    }

    if (_reactNativeWeb.Platform.OS === 'web') {
      for (var i = 0; i <= daysDiff; i++) {
        var e = document.getElementById("hotel-View-".concat(newDate.getFullYear(), "-").concat(newDate.getMonth(), "-").concat(newDate.getDate()));
        newDate = _AaCalendar.AaCalendarUtilities.subtractDaysToDate(newDate, 1);

        if (!e) {
          continue;
        }

        e.style.background = "none";
      }
    }

    if (_reactNativeWeb.Platform.OS === 'android' || _reactNativeWeb.Platform.OS === "ios") {
      for (var _i = 0; _i <= daysDiff; _i++) {
        var _e2 = itemsRef.current["hotel-View-".concat(newDate.getFullYear(), "-").concat(newDate.getMonth(), "-").concat(newDate.getDate())];
        newDate = _AaCalendar.AaCalendarUtilities.subtractDaysToDate(newDate, 1);

        if (!_e2) {
          continue;
        }

        _e2.setNativeProps({
          backgroundColor: "#FFF"
        });
      }
    }
  }; // const resetHover = (currentHoveredDate) => {
  //     if(!currentHoveredDate || !lastHoveredDate){
  //         return;
  //     }
  //     let newDate = lastHoveredDate;
  //     let daysDiff = AaCalendarUtilities.dayDifference(currentHoveredDate, lastHoveredDate);
  //     if(daysDiff < 0 || Number.isNaN(daysDiff)){
  //         return false
  //     }
  //     for(let i = 0; i <= daysDiff; i++){
  //         if(Platform.OS === 'web'){
  //             let e =  document.getElementById(`View-${newDate.getFullYear()}-${newDate.getMonth()}-${newDate.getDate()}`);
  //             if(!e){
  //                 return;
  //             }
  //             newDate = AaCalendarUtilities.subtractDaysToDate(newDate, 1);
  //             e.style.background = "none";
  //         }
  //         if(Platform.OS === 'android' || Platform.OS === "ios"){
  //             let e = itemsRef.current[`View-${newDate.getFullYear()}-${newDate.getMonth()}-${newDate.getDate()}`];
  //             if(!e){
  //                 return;
  //             }
  //             newDate = AaCalendarUtilities.subtractDaysToDate(newDate, 1);
  //             e.setNativeProps({
  //                 backgroundColor: "#FFF"
  //             });
  //         }
  //      }
  // };


  (0, _react.useEffect)(function () {
    if (props.data.checkinDate.year && props.data.checkinDate.month && props.data.checkinDate.date && props.data.checkoutDate.year && props.data.checkoutDate.month && props.data.checkoutDate.date) {
      onHoverDates(new Date(props.data.checkinDate.year, props.data.checkinDate.month, props.data.checkinDate.date), new Date(props.data.checkoutDate.year, props.data.checkoutDate.month, props.data.checkoutDate.date));
    }
  }, [props.data.checkinDate, props.data.checkoutDate]);
  return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, null, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, null, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: styles.calendarHeaderContainer
  }, props.controls.showPrevButton && /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.TouchableWithoutFeedback, {
    accessible: _reactNativeWeb.Platform.OS === 'web' ? false : true,
    onPress: props.controls.onPrevButtonClicked
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: [styles.calendarNavButton, !props.controls.enablePrevButton ? styles.disableButton : null]
  }, /*#__PURE__*/_react["default"].createElement(_crossPlatformComponents.AaIconComponent, {
    controls: {
      iconName: "ARROW_RIGHT",
      iconStyle: {
        height: 24,
        width: 24
      }
    }
  }))), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
    style: [styles.label, styles.calendarHeaderItem]
  }, calendarLabel), props.controls.showNextButton && /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.TouchableWithoutFeedback, {
    accessible: _reactNativeWeb.Platform.OS === 'web' ? false : true,
    onPress: props.controls.onNextButtonClicked
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: [styles.calendarNavButton, !props.controls.enableNextButton ? styles.disableButton : null]
  }, /*#__PURE__*/_react["default"].createElement(_crossPlatformComponents.AaIconComponent, {
    controls: {
      iconName: "ARROW_LEFT",
      iconStyle: {
        height: 24,
        width: 24
      }
    }
  })))), props.controls.showDaysDisplay && /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: [styles.week, styles.dayNames]
  }, weekDaysNames.map(function (day, index) {
    return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
      key: "".concat(props.controls.calendarIndex, "-").concat(weekDaysKeys[index]),
      style: [styles.calendarItem, styles.dayStyling]
    }, day);
  }))), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, null, weeks.map(function (day, windex) {
    return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: styles.week,
      key: "hotel-Week-".concat(windex)
    }, day.map(function (d, index) {
      return /*#__PURE__*/_react["default"].createElement(_crossPlatformComponents.AaHoverable, {
        key: "hotel-View-".concat(dateObj.getFullYear(), "-").concat(dateObj.getMonth(), "-").concat(windex, "-").concat(index, "-").concat(d)
      }, function (isHovered) {
        return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
          style: [styles.dayButton, isHovered && props.data.checkinDate.month && !props.data.checkoutDate.month && onHoverDates(new Date(props.data.checkinDate.year, props.data.checkinDate.month, props.data.checkinDate.date), new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label))]
        }, d.label !== " " ? /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.TouchableWithoutFeedback, {
          accessible: _reactNativeWeb.Platform.OS === 'web' ? false : true,
          onPress: function onPress() {
            return dayPress(d);
          }
        }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
          style: {
            flex: 1,
            width: '100%',
            alignItems: 'center'
          }
        }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
          nativeID: "hotel-View-".concat(dateObj.getFullYear(), "-").concat(dateObj.getMonth(), "-").concat(d.label),
          ref: function ref(r) {
            return itemsRef.current["hotel-View-".concat(dateObj.getFullYear(), "-").concat(dateObj.getMonth(), "-").concat(d.label)] = r;
          },
          style: [styles.emptyBackgrounrContainer, checkIfDateAreSame(new Date(props.data.checkinDate.year, props.data.checkinDate.month, props.data.checkinDate.date), new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label)) && styles.checkinDateBorderRadius, checkIfDateAreSame(new Date(props.data.checkoutDate.year, props.data.checkoutDate.month, props.data.checkoutDate.date), new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label)) && styles.checkoutDateBorderRadius]
        }), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
          style: [styles.calendarItem, isHovered && props.data.checkinDate.month && !props.data.checkoutDate.month && toHover(d.label) && styles.calendarItemActive, checkIfDateAreSame(new Date(props.data.checkinDate.year, props.data.checkinDate.month, props.data.checkinDate.date), new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label)) || checkIfDateAreSame(new Date(props.data.checkoutDate.year, props.data.checkoutDate.month, props.data.checkoutDate.date), new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label)) ? styles.calendarItemActive : null, !checkIfDateIsPreviousOrEqualOfStartDate(new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label), maxDate) || checkIfDateIsPreviousOfStartDate(new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label), today) ? styles.disableButton : null]
        }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
          style: [styles.dayStyling, isHovered && props.data.checkinDate.month && !props.data.checkoutDate.month && toHover(d.label) && styles.calendarTextActive, checkIfDateAreSame(new Date(props.data.checkinDate.year, props.data.checkinDate.month, props.data.checkinDate.date), new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label)) || checkIfDateAreSame(new Date(props.data.checkoutDate.year, props.data.checkoutDate.month, props.data.checkoutDate.date), new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label)) ? styles.calendarTextActive : null, !checkIfDateIsPreviousOrEqualOfStartDate(new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label), maxDate) || checkIfDateIsPreviousOfStartDate(new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label), today) ? styles.disableCalendarItem : null],
          key: "".concat(dateObj.getFullYear(), "-").concat(dateObj.getMonth(), "-").concat(d.label)
        }, d.label), isPriceLoaded && /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
          style: [styles.calendarTextPrice, isHovered && props.data.checkinDate.month && !props.data.checkoutDate.month && toHover(d.label) && styles.calendarTextActive, checkIfDateAreSame(new Date(props.data.checkinDate.year, props.data.checkinDate.month, props.data.checkinDate.date), new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label)) || checkIfDateAreSame(new Date(props.data.checkoutDate.year, props.data.checkoutDate.month, props.data.checkoutDate.date), new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label)) ? styles.calendarTextActive : null, !checkIfDateIsPreviousOrEqualOfStartDate(new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label), maxDate) || checkIfDateIsPreviousOfStartDate(new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label), today) ? styles.disableCalendarItem : null],
          key: "price-".concat(dateObj.getFullYear(), "-").concat(dateObj.getMonth(), "-").concat(d.label)
        }, checkIfDateIsPreviousOrEqualOfStartDate(new Date(dateObj.getFullYear(), dateObj.getMonth(), d.label), new Date(props.data.checkinDate.year, props.data.checkinDate.month, props.data.checkinDate.date)) && props.controls.selectionType === _AaCalendar2.CALENDAR_SELECTION_TYPE.TWO ? ' ' : _AaCalendar.AaCalendarUtilities.currencySymbolFormatter(d.price, props.controls.currencyDetails ? props.controls.currencyDetails : ''))))) : /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
          style: [styles.calendarItem, props.data.checkinDate === d.label || props.data.checkoutDate === d.label ? styles.calendarItemActive : null]
        }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
          key: "".concat(dateObj.getFullYear(), "-").concat(dateObj.getMonth(), "-").concat(d.label)
        }, d.label)));
      });
    }));
  })));
};

var styles = _crossPlatformComponents.StyleSheet.create({
  calendarHeaderContainer: {
    flexDirection: 'row',
    justifyContent: "center",
    alignItems: 'center',
    flex: 1,
    paddingVertical: 15,
    web: {
      minHeight: 54
    }
  },
  calendarHeaderItem: {
    flex: 1,
    fontSize: 16,
    color: '#212124',
    fontFamily: _uiUtils.DefaultTokens.FONT_MEDIUM,
    web: {
      fontFamily: _uiUtils.DefaultTokens.FONT_WEB,
      fontWeight: '400'
    }
  },
  calendarNavButton: {
    web: {
      cursor: "pointer"
    }
  },
  disableButton: {
    web: {
      cursor: "not-allowed"
    }
  },
  dayNames: {
    marginBottom: 15
  },
  week: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  dayButton: {
    position: 'relative',
    // "&:hover": {
    //     backgroundColor: 'red'
    // },
    backgroundColor: 'transparent',
    flex: 1,
    width: 46,
    height: 46,
    alignItems: 'center',
    justifyContent: 'center' // maxWidth: 46

  },
  emptyBackgrounrContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%'
  },
  checkinDateBorderRadius: {
    width: '50%',
    left: '50%' // borderTopLeftRadius: 46/2,
    // borderBottomLeftRadius: 46/2

  },
  checkoutDateBorderRadius: {
    width: '50%',
    right: '50%' // borderTopRightRadius: 46/2,
    // borderBottomRightRadius: 46/2

  },
  onHover: {
    backgroundColor: 'red'
  },
  dayButtonActive: {// backgroundColor: '#4b4fa6',
    // borderRadius: '50%'
  },
  calendarItem: {
    flex: 1,
    textAlign: 'center',
    paddingBottom: 3,
    color: 'black',
    width: 46,
    alignItems: 'center',
    justifyContent: 'center',
    web: {
      cursor: 'pointer'
    }
  },
  calendarItemActive: {
    backgroundColor: '#4b4fa6',
    borderRadius: 55 / 2
  },
  calendarTextActive: {
    color: 'white'
  },
  calendarTextPrice: {
    fontSize: 10,
    color: '#1d1d1d',
    fontFamily: _uiUtils.DefaultTokens.FONT_REGULAR,
    web: {
      fontFamily: _uiUtils.DefaultTokens.FONT_WEB
    }
  },
  disableCalendarItem: {
    color: '#e2e2e2'
  },
  label: {
    fontWeight: "500",
    textAlign: 'center'
  },
  dayStyling: {
    fontSize: 14,
    color: '#1d1d1d',
    fontFamily: _uiUtils.DefaultTokens.FONT_REGULAR,
    web: {
      fontFamily: _uiUtils.DefaultTokens.FONT_WEB,
      fontWeight: '400'
    }
  }
});

var _default = AaCalendarInstance;
exports["default"] = _default;